import styled from 'styled-components';

export const Form = styled.form`
  width: 100%;
  padding: 20px;

  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const NicknameChangeButton = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;

  padding: 4px 8px;
`;

export const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
  background-color: yellow;

  display: inline-flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const Links = styled.div`
  width: 100%;
  padding: 0px 20px;

  display: flex;
  flex-direction: column;
`;

export const Link = styled.div`
  width: 100%;
  padding: 8px 0px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LinkIconWrapper = styled.div`
  svg {
    width: 16px;
    height: 16px;

    path {
      fill: ${({ theme }) => theme['font-secondary']};
    }
  }
`;
